
import { useState } from 'react';
import { SidebarProvider } from '@/components/ui/sidebar';
import AdminLayout from '@/components/AdminLayout';
import AdminCalendarTab from '@/components/AdminCalendarTab';
import AdminPropertiesTab from '@/components/AdminPropertiesTab';
import AdminGuestsTab from '@/components/AdminGuestsTab';
import AdminBookingsTab from '@/components/AdminBookingsTab';
import UserManagementTabs from '@/components/UserManagementTabs';
import AdminSidebar from '@/components/AdminSidebar';

const Admin = () => {
  const [activeTab, setActiveTab] = useState('properties');

  const renderTabContent = () => {
    switch (activeTab) {
      case 'properties':
        return <AdminPropertiesTab />;
      case 'guests':
        return <AdminGuestsTab />;
      case 'bookings':
        return <AdminBookingsTab />;
      case 'calendar':
        return <AdminCalendarTab />;
      case 'users':
        return <UserManagementTabs />;
      default:
        return <AdminPropertiesTab />;
    }
  };

  return (
    <AdminLayout>
      <SidebarProvider>
        <div className="min-h-screen flex w-full">
          <AdminSidebar activeTab={activeTab} onTabChange={setActiveTab} />
          
          <main className="flex-1">
            <div className="p-6">
              {renderTabContent()}
            </div>
          </main>
        </div>
      </SidebarProvider>
    </AdminLayout>
  );
};

export default Admin;
